/**
 * Merk + kleur van een winkel voor een klein label ("IXINA Lochristi" blauw, "VDBK Oostakker" rood).
 * Puur (geen DB) zodat server én client dezelfde regel gebruiken.
 */
import { LEGACY_PRIMAIR, DEFAULT_PRIMAIR, isNietIngesteld } from './kordaroBrand.js';

export type WinkelMerk = 'ixina' | 'vdbk' | null;

export const MERK_KLEUR: Record<'ixina' | 'vdbk', string> = { ixina: '#284B73', vdbk: '#FF3640' };
/** Default van WinkelBranding.kleurPrimair in het schema — betekent "niet ingesteld". */
export const BRANDING_DEFAULT_KLEUR = LEGACY_PRIMAIR;
const NEUTRAAL = '#4B5563';

export function merkVanNaam(naam: string | null | undefined): WinkelMerk {
  const n = (naam ?? '').toLowerCase();
  if (/\bixina\b/.test(n)) return 'ixina';
  if (/\bvdbk\b|vanden\s*borre\s*kitchen|vandenborre\s*kitchen/.test(n)) return 'vdbk';
  return null;
}

/** Kleur: WinkelBranding.kleurPrimair indien bewust ingesteld, anders merkkleur, anders neutraal. */
export function winkelKleur(naam: string | null | undefined, kleurPrimair?: string | null): string {
  if (kleurPrimair && !isNietIngesteld(kleurPrimair) && kleurPrimair.toUpperCase() !== DEFAULT_PRIMAIR) return kleurPrimair;
  const merk = merkVanNaam(naam);
  return merk ? MERK_KLEUR[merk] : (kleurPrimair || NEUTRAAL);
}
